/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_requestUserNotificationLog_requestCountUnreadRequestUserNotificationLog } from '../models/api_requestUserNotificationLog_requestCountUnreadRequestUserNotificationLog';
import type { api_requestUserNotificationLog_requestListRequestUserNotificationLog } from '../models/api_requestUserNotificationLog_requestListRequestUserNotificationLog';
import type { api_requestUserNotificationLog_requestUpdateIsRead } from '../models/api_requestUserNotificationLog_requestUpdateIsRead';
import type { api_requestUserNotificationLog_responseCountUnreadRequestUserNotificationLog } from '../models/api_requestUserNotificationLog_responseCountUnreadRequestUserNotificationLog';
import type { api_requestUserNotificationLog_responseListRequestUserNotificationLog } from '../models/api_requestUserNotificationLog_responseListRequestUserNotificationLog';
import type { api_requestUserNotificationLog_responseUpdateIsRead } from '../models/api_requestUserNotificationLog_responseUpdateIsRead';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RequestUserNotificationLogService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Count Unread RequestUserNotificationLog
     * 利用ユーザー宛の未読通知履歴の件数を取得する。
     * @returns api_requestUserNotificationLog_responseCountUnreadRequestUserNotificationLog responseCountUnreadRequestUserNotificationLog
     * @throws ApiError
     */
    public postRequestUserNotificationLogCountUnread({
        body,
    }: {
        /**
         * requestCountUnreadRequestUserNotificationLog
         */
        body: api_requestUserNotificationLog_requestCountUnreadRequestUserNotificationLog,
    }): CancelablePromise<api_requestUserNotificationLog_responseCountUnreadRequestUserNotificationLog> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_notification_log/count_unread',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List RequestUserNotificationLog
     * 利用ユーザー宛の通知履歴の一覧を取得する。
     * @returns api_requestUserNotificationLog_responseListRequestUserNotificationLog responseListRequestUserNotificationLog
     * @throws ApiError
     */
    public postRequestUserNotificationLogList({
        body,
    }: {
        /**
         * requestListRequestUserNotificationLog
         */
        body: api_requestUserNotificationLog_requestListRequestUserNotificationLog,
    }): CancelablePromise<api_requestUserNotificationLog_responseListRequestUserNotificationLog> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_notification_log/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update RequestUserNotificationLog IsRead
     * 利用ユーザー宛の通知履歴を既読にする。
     * @returns api_requestUserNotificationLog_responseUpdateIsRead responseUpdateIsRead
     * @throws ApiError
     */
    public postRequestUserNotificationLogUpdateIsRead({
        body,
    }: {
        /**
         * requestUpdateIsRead
         */
        body: api_requestUserNotificationLog_requestUpdateIsRead,
    }): CancelablePromise<api_requestUserNotificationLog_responseUpdateIsRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_notification_log/update_is_read',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
